import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
} from '@chakra-ui/react'
import { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { Input, Textarea } from '@/components/Form'
import useZZZ6 from '../../useZZZ6'

const ZZZ6DetailModal = ({ modalDetail, setModalDetail }) => {
  const { show, isCreate, detail } = modalDetail

  const methods = useForm({
    defaultValues: {
      ZZ6: '',
      description: '',
      HScode: '',
      country: '',
      AL: '',
      ECCN: '',
      ESN: '',
      Remarks: '',
      Category: '',
    },
  })

  const { useCreateZZZ6, useUpdateZZZ6 } = useZZZ6()
  const createZZZ6 = useCreateZZZ6()
  const updateZZZ6 = useUpdateZZZ6()

  useEffect(() => {
    if (detail && !isCreate) {
      methods.reset({
        ZZ6: detail.ZZ6 || '',
        description: detail.description || '',
        HScode: detail.HScode || '',
        country: Array.isArray(detail.country) ? detail.country.join(', ') : '',
        AL: detail.AL || '',
        ECCN: detail.ECCN || '',
        ESN: detail.ESN || '',
        Remarks: detail.Remarks || '',
        Category: Array.isArray(detail.Category) ? detail.Category.join(', ') : '',
      })
    } else {
      methods.reset({
        ZZ6: '',
        description: '',
        HScode: '',
        country: '',
        AL: '',
        ECCN: '',
        ESN: '',
        Remarks: '',
        Category: '',
      })
    }
  }, [detail, isCreate, methods])

  const onClose = () => {
    setModalDetail({ show: false })
    methods.reset()
  }

  const onSubmit = async (data) => {
    try {
      const transformedData = {
        ...data,
        country: data.country ? data.country.split(',').map((c) => c.trim()) : [],
        Category: data.Category ? data.Category.split(',').map((c) => c.trim()) : [],
      }

      if (isCreate) {
        await createZZZ6.mutateAsync(transformedData)
      } else {
        await updateZZZ6.mutateAsync({
          id: detail._id,
          data: transformedData,
        })
      }
      onClose()
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Modal isOpen={show} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{isCreate ? 'Create' : 'Edit'} ZZ6</ModalHeader>
        <ModalCloseButton />
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <ModalBody>
              <Flex direction="column" gap={4}>
                <Input name="ZZ6" label="ZZ6" isRequired />
                <Input name="description" label="Description" />
                <Input name="HScode" label="HS Code" />
                <Textarea name="country" label="Country (comma-separated)" placeholder="e.g. US, CN, JP" isRequired />
                <Input name="AL" label="AL" />
                <Input name="ECCN" label="ECCN" />
                <Input name="ESN" label="ESN" />
                <Textarea name="Remarks" label="Remarks" />
                <Textarea
                  name="Category"
                  label="Category (comma-separated)"
                  placeholder="e.g. Electronics, Hardware"
                  isRequired
                />
              </Flex>
            </ModalBody>
            <ModalFooter>
              <Spacer />
              <Button variant="ghost" mr={3} onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme="blue" type="submit" isLoading={createZZZ6.isLoading || updateZZZ6.isLoading}>
                {isCreate ? 'Create' : 'Update'}
              </Button>
            </ModalFooter>
          </form>
        </FormProvider>
      </ModalContent>
    </Modal>
  )
}

export default ZZZ6DetailModal
